import { Tabs, TabType } from '@eltoro-ui/components'
import { ETIcon } from 'Assets'
import { AudienceUploadStepper } from 'Components/AudienceUploadContainer'
import { PolygonMap } from 'Components/PolygonMap'
import { styleTailwind } from 'Helpers'
import { Targetjobservicev1Audience } from 'next-gen-sdk'
import { audienceUploadConfigs } from 'Pages'

const AudienceCat = styleTailwind(
  'span',
  'AudienceHeader__category whitespace-nowrap',
)

export const DigitalCanvassingTab = (
  handleAddAudience: (
    audiences: Targetjobservicev1Audience[],
    confirmation?: boolean,
  ) => void,
): TabType => {
  return {
    id: 'dc',
    label: (
      <>
        <ETIcon icon="digital-canvassing" />
        <span className="AudienceTypeSelector__tabs--text flex flex-col">
          <span className="AudienceTypeSelector__tabs-category Tabs-category">
            Location
          </span>
          <AudienceCat>Digital Canvassing</AudienceCat>
        </span>
      </>
    ),
    component: (
      <AudienceUploadStepper
        audienceType="dc"
        onAddAudienceToAttach={handleAddAudience}
        useInCampaignButton={false}
      />
    ),
  } as TabType
}

export const VenueReplayTab = (
  handleAddAudience: (
    audiences: Targetjobservicev1Audience[],
    confirmation?: boolean,
  ) => void,
): TabType => {
  return {
    id: 'vr',
    label: (
      <>
        <ETIcon icon="venue-replay" />
        <span className="AudienceTypeSelector__tabs--text flex flex-col">
          <span className="AudienceTypeSelector__tabs-category Tabs-category">
            Behavioral
          </span>
          <AudienceCat>Venue Replay</AudienceCat>
        </span>
      </>
    ),
    component: <PolygonMap vr onAddAudienceToAttach={handleAddAudience} />,
  }
}

export const NewMoverTab = (
  handleAddAudience: (
    audiences: Targetjobservicev1Audience[],
    confirmation?: boolean,
  ) => void,
): TabType => {
  return {
    id: 'movers',
    label: (
      <>
        <ETIcon className="AudienceTypeSelector__tabs--icon" icon="movers" />
        <span className="AudienceTypeSelector__tabs--text flex flex-col">
          <span className="AudienceTypeSelector__tabs-category Tabs-category">
            Behavioral
          </span>
          <AudienceCat>Digital New Mover</AudienceCat>
        </span>
      </>
    ),
    component: (
      <AudienceUploadStepper
        audienceType="new-mover"
        onAddAudienceToAttach={handleAddAudience}
      />
    ),
  }
}

export const MapPolygonTab = (
  handleAddAudience: (
    audiences: Targetjobservicev1Audience[],
    confirmation?: boolean,
  ) => void,
): TabType => {
  return {
    id: 'map',
    label: (
      <>
        <ETIcon icon="map-polygon" />
        <span className="AudienceTypeSelector__tabs--text flex flex-col">
          <span className="AudienceTypeSelector__tabs-category Tabs-category">
            Location
          </span>
          <AudienceCat>Map Polygon</AudienceCat>
        </span>
      </>
    ),
    component: (
      <PolygonMap vr={false} onAddAudienceToAttach={handleAddAudience} />
    ),
  }
}

export const IpTargetingTab = (
  handleAddAudience: (
    audiences: Targetjobservicev1Audience[],
    confirmation?: boolean,
  ) => void,
  isAdmin?: boolean,
): TabType => {
  const uploadConfigs = audienceUploadConfigs.filter(
    ({ id }) =>
      id === 'address' ||
      id === 'zip' ||
      id === 'ip' ||
      (isAdmin && id === 'custom'),
  )
  return {
    id: 'Ip Targeting',
    label: (
      <>
        <ETIcon className="AudienceTypeSelector__tabs--icon" icon="sale-doc" />
        <span className="AudienceTypeSelector__tabs--text flex flex-col">
          <span className="AudienceTypeSelector__tabs-category Tabs-category">
            Address
          </span>
          <AudienceCat>IP Address List</AudienceCat>
        </span>
      </>
    ),
    component: (
      <Tabs
        tabs={uploadConfigs.map((config) => {
          return {
            id: config.id,
            label: (
              <>
                {config.icon}
                <span className="flex flex-col">
                  <div className="EditOLTagets__tabs-category Tabs-category">
                    {config.tagLabel}
                  </div>
                  <span>{config.title}</span>
                </span>
              </>
            ),
            component: (
              <div className="mt-2">
                <AudienceUploadStepper
                  audienceType={config.id}
                  onAddAudienceToAttach={handleAddAudience}
                  useInCampaignButton={false}
                />
              </div>
            ),
          }
        })}
      />
    ),
  }
}
